import {
	AUTH_REQUEST,
	AUTH_REGISTER,
	AUTH_SUB,
	SHARE_PROP,
	ABOUT_FORM,
	AUTH_ERROR,
	AUTH_LOGOUT,
	AUTH_SUCCESS,
	PASS_RESET,
	USER_REQUEST,
	NEW_ORDER,
	AUTH_FORGOT,
	AUTH_RESET,
	TOKEN_DECODE,
} from "../../constants";
import api from "../../utils/api";
import localData from "../../utils/localdata";
import jwt_decode from "jwt-decode";

const actions = {
	[AUTH_REQUEST]: ({ commit, dispatch }, user) => {
		return new Promise(async (resolve, reject) => {
			commit(AUTH_REQUEST);
			try {
				const resp = await api.post("/api/v1/login", user);
				const token = resp.token;
				localData.setItem("user-token", token);
				localData.setItem("user-id", resp.user.id); // store the token in localstorage
				commit(AUTH_SUCCESS, { token: token, userId: resp.user.id });
				dispatch(USER_REQUEST);
				resolve(resp);
			} catch (err) {
				commit(AUTH_ERROR, err);
				localData.removeItem("user-token"); // if the request fails, remove any possible user token if possible
				localData.removeItem("user-id");
				reject(err);
			}
		});
	},
	[AUTH_REGISTER]: ({ commit, dispatch }, user) => {
		user.password2 = user.password;
		return new Promise(async (resolve, reject) => {
			commit(AUTH_REGISTER);
			try {
				const resp = await api.post("/api/v1/register", user);
				const token = resp.token;
				// localData.setItem("user-token", token); // store the token in localstorage
				// localData.setItem("user-id", resp.user.id);
				// commit(AUTH_SUCCESS, { token: token, userId: resp.user.id });
				// dispatch(USER_REQUEST);
				resolve(resp);
			} catch (err) {
				commit(AUTH_ERROR, err);
				localData.removeItem("user-token"); // if the request fails, remove any possible user token if possible
				localData.removeItem("user-id");
				reject(err);
			}
		});
	},
	[AUTH_SUB]: ({}, data) => {
		return new Promise(async (resolve, reject) => {
			try {
				const resp = await api.post("/api/v1/contact/lead", data);
				resolve(resp);
			} catch (err) {
				reject(err);
			}
		});
	},
	[SHARE_PROP]: ({}, data) => {
		return new Promise(async (resolve, reject) => {
			try {
				const resp = await api.post("/api/v1/contact/share", data);
				resolve(resp);
			} catch (err) {
				reject(err);
			}
		});
	},
	[ABOUT_FORM]: ({}, data) => {
		return new Promise(async (resolve, reject) => {
			try {
				const resp = await api.post("/api/v1/contact/about-form", data);
				resolve(resp);
			} catch (err) {
				reject(err);
			}
		});
	},
	[AUTH_FORGOT]: ({ commit, dispatch }, user) => {
		return new Promise(async (resolve, reject) => {
			commit(AUTH_REGISTER);
			try {
				const resp = await api.post("/api/v1/forgot-password", user);
				resolve(resp);
			} catch (err) {
				commit(AUTH_ERROR, err);
				reject(err);
			}
		});
	},
	[AUTH_RESET]: ({ commit, dispatch }, user) => {
		return new Promise(async (resolve, reject) => {
			commit(AUTH_REGISTER);
			try {
				const resp = await api.post("/api/v1/forgot-password-reset", user);
				resolve(resp);
			} catch (err) {
				commit(AUTH_ERROR, err);
				reject(err);
			}
		});
	},
	[NEW_ORDER]: ({ commit, dispatch }, order) => {
		return new Promise(async (resolve, reject) => {
			try {
				const resp = await api.post("/api/v1/order", order);
				resolve(resp);
			} catch (err) {
				reject(err);
			}
		});
	},
	[PASS_RESET]: ({ commit, dispatch }, data) => {
		return new Promise(async (resolve, reject) => {
			try {
				const resp = await api.post("/api/v1/user/reset-password", data);
				resolve(resp);
			} catch (err) {
				reject(err);
			}
		});
	},
	[AUTH_LOGOUT]: ({ commit, dispatch }) => {
		return new Promise((resolve, reject) => {
			commit(AUTH_LOGOUT);
			localData.removeItem("user-token"); // clear your user's token from localstorage
			localData.removeItem("user-id");
			resolve();
		});
	},
	[TOKEN_DECODE]: ({ state, dispatch }) => {
		if (state.token) {
			var decoded = jwt_decode(state.token);
			if (Date.now() >= decoded.exp * 1000) {
				dispatch(AUTH_LOGOUT);
			}
		}
	},
};

export default actions;
